import { addYears } from 'date-fns'

export default {
  name: 'project_end_date',
  component_path: 'modules/procedures/blocks/BlockInputDate',
  default_value: 'default_values.project.end_date',
  static_options: {
    open_date: new Date(),
    show_time: true
  },
  static_mandatory: [
    `minDate:${new Date().toISOString()}`,
    `maxDate:${addYears(new Date(), 10).toISOString()}`,
    'minDate:procedure.default_values.project.start_date',
    'minDate:procedure_execution.actions_data.project.start_date'
  ]
}